import { SingleValue } from 'react-select';
import { getIntelligenceViewDetails, IntelligenceView } from '../utils/constants';
import { Menu } from '../../../../../molecules/menu/Menu';
import { Option } from '../../../../../molecules/select/types';
import { Button } from 'reactstrap';
import { SingleSelect } from '../../../../../molecules/select/SingleSelect';

export const Header = ({
  view,
  setView,
  runOptions,
  selectedRunOption,
  onRunChange,
  onGenerateInsights,
  isGenerating,
}: {
  view: IntelligenceView;
  setView: (view: IntelligenceView) => void;
  runOptions: { label: string; value: string }[];
  selectedRunOption: { label: string; value: string } | null;
  onRunChange: (opt: SingleValue<Option<string> | null>) => void;
  onGenerateInsights: () => void;
  isGenerating: boolean;
}) => {
  return (
    <>
      {/* Dashboard Navigation */}
      <div className='d-flex mb-2 border-bottom flex-fill'>
        <Menu
          grouped={true}
          size='md'
          color='secondary'
          items={[
            {
              label: getIntelligenceViewDetails(IntelligenceView.Intelligence).menuLabel,
              active: view === IntelligenceView.Intelligence,
              onClick: () => setView(IntelligenceView.Intelligence),
            },
            {
              label: getIntelligenceViewDetails(IntelligenceView.Priorities).menuLabel,
              active: view === IntelligenceView.Priorities,
              onClick: () => setView(IntelligenceView.Priorities),
            },
            {
              label: getIntelligenceViewDetails(IntelligenceView.Recommendations).menuLabel,
              active: view === IntelligenceView.Recommendations,
              onClick: () => setView(IntelligenceView.Recommendations),
            },
          ]}
        />
        <div className='ms-auto text-end'>
          {runOptions.length === 0 ? (
            <Button color='primary' onClick={onGenerateInsights} disabled={isGenerating}>
              {isGenerating ? (
                <>
                  <i className='fas fa-spinner fa-spin me-2' />
                  Generating...
                </>
              ) : (
                'Generate Insights'
              )}
            </Button>
          ) : (
            <div className='d-flex gap-2'>
              <div style={{ width: '200px' }}>
                <SingleSelect
                  className='text-left w-100 ellipsis'
                  isTransparent
                  value={selectedRunOption}
                  onChange={onRunChange}
                  options={runOptions}
                />
              </div>
              <Button size='sm' color='transparent' onClick={onGenerateInsights} disabled={isGenerating}>
                <i className={`fas fa-refresh ${isGenerating ? 'fa-spin' : ''}`} />
              </Button>
            </div>
          )}
        </div>
      </div>
    </>
  );
};
